import styled from "styled-components";

export const QueryFormContainer = styled.div(
  (props) => `
    background: rgba(0,0,0,0.7);
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 9999999;
    left: 0;
    top: 0;
    overflow: scroll;
    scroll-behavior: smooth;

    div.outer {
        padding: 0;
        max-width: 1200px;
        margin: 0 auto;
        margin-top: 5%;

        div.contactManagementContainer {
            width: 520px;
            background: #fff;
            padding: 25px 25px;
            border-radius: 4px;
            position: absolute;
            left: 50%;
            top: 100px;
            transform: translateX(-50%);
            z-index: 9999;
            margin-bottom: 100px;

            div.contactManagementHdr {
                padding: 0;
                margin: 0;
                color: #4a4a4a;
                font-size: 14px;
                font-weight: 400;
                font-family: 'Rubik';

                p.closePopup {
                    position: fixed;
                    top: 26px;
                    right: 35px;
                    width: 18px;
                    height: 18px;
                    cursor: pointer;
                    margin: 0;
                    padding: 0;
                    list-style: none;
                }
                p.closePopup:before {
                    transform: rotate(45deg);
                    position: absolute;
                    left: 8px;
                    content: ' ';
                    height: 18px;
                    width: 2px;
                    background-color: #000;
                }

                p.closePopup:after {
                    transform: rotate(-45deg);
                    position: absolute;
                    left: 8px;
                    content: ' ';
                    height: 18px;
                    width: 2px;
                    background-color: #000;
                }
            }

            div.contactManagementForm {
                color: #000;
                padding-top: 20px;
                font-family: 'Rubik';

                div {
                    -webkit-box-direction: normal;
                    -webkit-box-orient: vertical;
                    flex-direction: column;
                    flex-wrap: wrap;
                    text-align: center;
                    display: flex;
                    margin-top: 15px;
                
                    p.tnkU {
                        margin-bottom: 15px;
                        display: flex;
                        justify-content: center;
                    }

                    p.thankYou {
                        font-weight: 600;
                        font-size: 26px;
                        line-height: 26px;
                        margin-bottom: 15px;
                    }

                    p.thankYouMsg {
                        color: #4a4a4a;
                        margin-bottom: 40px;
                    }
                }
            }
        }

    }
`
);